import { render, staticRenderFns } from "./RouteAreaReportDataTable.vue?vue&type=template&id=27316fa7&"
import script from "./RouteAreaReportDataTable.vue?vue&type=script&lang=js&"
export * from "./RouteAreaReportDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports